import Type from "@/model/types/Type";

const type = {
    CUSTOMER: 1,
    CREDITOR: 2,
    SUPPLIER: 3,
    EXECUTOR: 4,

}

const list = [
    {
        value: type.CUSTOMER,
        text: "Cliente",
        path: "customer",
        personId: "customerId",
        personNumber: "customerNumber",
    },
    {
        value: type.CREDITOR,
        text: "Credor",
        path: "financial/creditor",
        personId: "creditorId",
        personNumber: "creditorNumber",
    },
    {
        value: type.SUPPLIER,
        text: "Fornecedor",
        path: "financial/supplier",
        personId: "supplierId",
        personNumber: "personNumber",
    },

    {
        value: type.EXECUTOR,
        text: "Responsável",
        path: "agent/executor",
        personId: "executorId",
        personNumber: "executorNumber",
    },


]

const contains = function (typeInput) {
    return Type.contains(list, typeInput)
}

const getPath = function (type) {

    if (type > 0) {

        const path = list.find(a => a.value === type).path

        if (path !== undefined) {
            return path
        } else {
            return null
        }

    }

    const path = list.find(a => a.value === type).path

    if (path !== undefined) {
        return path
    } else {
        return null
    }

}

const getText = function (type) {

    if (type > 0) {

        const text = list.find(a => a.value === type).text

        if (text !== undefined) {
            return text
        } else {
            return null
        }

    }


}

export default {
    type,
    list,
    contains,
    getPath,
    getText,
}


